import React from "react";
import { UserRound } from "lucide-react";

const ProfileAvatar = () => (
  <div className="grid h-24 w-24 place-items-center rounded-full border-2 border-white bg-transparent">
    <div className="grid h-16 w-16 place-items-center rounded-full bg-white text-[#141414]">
      <UserRound size={34} strokeWidth={1.75} />
    </div>
  </div>
);

export default ProfileAvatar;
